import { apiRequest } from '@/api/client';
import type { OverviewSnapshot, SystemSettings } from '@/types/api';

/** The dashboard's numbers and the panel's own settings. Null where the server has none wired. */
export const systemApi = {
  overview: () => apiRequest<OverviewSnapshot | null>('/overview'),

  settings: () => apiRequest<SystemSettings | null>('/system/settings'),
};
